var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_521_28334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 10.7996C10.6 10.1369 11.1373 9.59961 11.8 9.59961H15.4C16.0627 9.59961 16.6 10.1369 16.6 10.7996V14.3996C16.6 15.0624 16.0627 15.5996 15.4 15.5996H11.8C11.1373 15.5996 10.6 15.0624 10.6 14.3996V10.7996ZM13 13.1996V11.9996H14.2V13.1996H13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 21.5996C10.6 20.9369 11.1373 20.3996 11.8 20.3996H15.4C16.0627 20.3996 16.6 20.9369 16.6 21.5996V25.1996C16.6 25.8623 16.0627 26.3996 15.4 26.3996H11.8C11.1373 26.3996 10.6 25.8623 10.6 25.1996V21.5996ZM13 23.9996V22.7996H14.2V23.9996H13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6 9.59961C21.9373 9.59961 21.4 10.1369 21.4 10.7996V14.3996C21.4 15.0624 21.9373 15.5996 22.6 15.5996H26.2C26.8627 15.5996 27.4 15.0624 27.4 14.3996V10.7996C27.4 10.1369 26.8627 9.59961 26.2 9.59961H22.6ZM23.8 11.9996V13.1996H25V11.9996H23.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 10.7996C20.2 10.1369 19.6627 9.59961 19 9.59961C18.3373 9.59961 17.8 10.1369 17.8 10.7996V11.9996C17.8 12.6624 18.3373 13.1996 19 13.1996C19.6627 13.1996 20.2 12.6624 20.2 11.9996V10.7996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14.3996C19.6627 14.3996 20.2 14.9369 20.2 15.5996V16.7996H22.6C23.2627 16.7996 23.8 17.3369 23.8 17.9996C23.8 18.6624 23.2627 19.1996 22.6 19.1996H19C18.3373 19.1996 17.8 18.6624 17.8 17.9996V15.5996C17.8 14.9369 18.3373 14.3996 19 14.3996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 16.7996C25.5373 16.7996 25 17.3369 25 17.9996C25 18.6624 25.5373 19.1996 26.2 19.1996C26.8627 19.1996 27.4 18.6624 27.4 17.9996C27.4 17.3369 26.8627 16.7996 26.2 16.7996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 21.5996C17.8 20.9369 18.3373 20.3996 19 20.3996H20.2C20.8627 20.3996 21.4 20.9369 21.4 21.5996C21.4 22.2624 20.8627 22.7996 20.2 22.7996V25.1996C20.2 25.8623 19.6627 26.3996 19 26.3996C18.3373 26.3996 17.8 25.8623 17.8 25.1996V21.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 19.1996C16.0627 19.1996 16.6 18.6624 16.6 17.9996C16.6 17.3369 16.0627 16.7996 15.4 16.7996H11.8C11.1373 16.7996 10.6 17.3369 10.6 17.9996C10.6 18.6624 11.1373 19.1996 11.8 19.1996H15.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 21.5996C27.4 22.2624 26.8627 22.7996 26.2 22.7996H23.8C23.1373 22.7996 22.6 22.2624 22.6 21.5996C22.6 20.9369 23.1373 20.3996 23.8 20.3996H26.2C26.8627 20.3996 27.4 20.9369 27.4 21.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 26.3996C26.8627 26.3996 27.4 25.8623 27.4 25.1996C27.4 24.5369 26.8627 23.9996 26.2 23.9996H22.6C21.9373 23.9996 21.4 24.5369 21.4 25.1996C21.4 25.8624 21.9373 26.3996 22.6 26.3996H26.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_521_28334",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_521_28334"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_521_28334",
    result: "effect2_dropShadow_521_28334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_521_28334",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan-icon.bcf4541ea91aba9829674b73488c5868.svg";
export { ForwardRef as ReactComponent };